// extracted by mini-css-extract-plugin
export var addButton = "_dc-0";
export var border = "_dc-8";
export var check = "_dc-h";
export var danger = "_dc-6";
export var dropdownContainer = "_dc-1";
export var editModalBody = "_dc-j";
export var footerContainer = "_dc-i";
export var fullWidth = "_dc-a";
export var hide = "_dc-9";
export var icon = "_dc-3";
export var input = "_dc-7";
export var inputFlex = "_dc-b";
export var inputWrapper = "_dc-c";
export var manualFocus = "_dc-5";
export var optionButton = "_dc-4";
export var pillWrapper = "_dc-e";
export var pointer = "_dc-2";
export var showOverflow = "_dc-f";
export var tagsFlex = "_dc-d";
export var xButton = "_dc-g";